import { MarkdownContent } from "@/components/ui/markdown-content";
import { t } from "@/lib/typography";
import type { PracticeLabStepResponse } from "@/types/practice-lab";

// Static content for the active step: "ties-to" tag, title, theory + instructions
// through the shared markdown renderer.
export function StepPanel({ step }: { step: PracticeLabStepResponse }) {
  return (
    <div className="space-y-3">
      {step.ties_to && (
        <span className="inline-flex items-center rounded-md bg-secondary px-2.5 py-1 text-xs font-medium text-secondary-foreground">
          Ties to · {step.ties_to}
        </span>
      )}
      <h2 className={t.sectionTitle}>{step.title}</h2>
      <MarkdownContent>{step.theory_md}</MarkdownContent>
      {step.instructions_md && <MarkdownContent>{step.instructions_md}</MarkdownContent>}
    </div>
  );
}
